









import Vue from 'vue'

export default Vue.extend({
  methods: {
    onClick(): void {
      const pathSegments = this.$route.path.split('/')
      const prevPath =
        pathSegments.slice(0, -1).join('/') ||
        (this.$router as any).options.base

      this.$router
        .push(prevPath)
        // TOPページへの遷移時になぜかundefinedがthrowされる(動作は正常)のでundefinedは無視する
        .catch((e) => e && Promise.reject(e))
      this.$emit('modalHeaderBack')
    },
  },
})
